import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../Images/LOGO 1.png'
import socialIcon1 from '../Images/1.png'
import socialIcon2 from '../Images/2.png'
import socialIcon4 from '../Images/4.png'
import socialIcon5 from '../Images/5.png'

function Footer() {
    return (
        <>
            <div>
                <footer
                    className="text-center text-lg-start text-white"
                    style={{ backgroundColor: "#1c2331" }}
                >
                    <section className="py-2">
                        <div className="container ms-auto text-center text-md-start mt-5">
                            <div className="row mt-3">
                                <div className="col-md-2 col-lg-3 col-xl-3">

                                    <h6 className="text-uppercase fw-bold">Quick Links</h6>

                                    <hr
                                        className="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#89c764", height: "2px" }}
                                    />

                                    <p>
                                        <Link to="/about" className="text-white text-decoration-none">
                                            About
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/contact" className="text-white text-decoration-none">
                                            Contact
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/login" className="text-white text-decoration-none">
                                            Login
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/blog" className="text-white text-decoration-none">
                                            Blog
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/faq" className="text-white text-decoration-none">
                                            FAQ
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/privacy-policy" className="text-white text-decoration-none">
                                            Privacy Policy
                                        </Link>
                                    </p>

                                    <p>
                                        <Link to="/terms" className="text-white text-decoration-none">
                                            Terms & Conditions
                                        </Link>
                                    </p>

                                </div>
                                <div className="col-md-2 col-lg-3 col-xl-3" >
                                    <h6 className="text-uppercase fw-bold">Compliance</h6>
                                    <hr
                                        className="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#89c764", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">MSME Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">FSSAI Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Trademark Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">ISO certification</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Company law compliance</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">LLP law compliance</a>
                                    </p>
                                </div>
                                <div className="col-md-2 col-lg-3 col-xl-3" >

                                    <h6 className="text-uppercase fw-bold">Compliance</h6>
                                    <hr
                                        className="mb-4 mt-0 d-inline-block mx-auto"
                                        style={{ width: "60px", backgroundColor: "#89c764", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">MSME Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">FSSAI Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Trademark Registration</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">ISO certification</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Company law compliance</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">LLP law compliance</a>
                                    </p>
                                </div>
                                <div className="col-md-3 col-lg-3 col-xl-3">

                                    <h6 className="text-uppercase fw-bold">Investments</h6>
                                    <hr
                                        className="mb-4 mt-0 d-inline-block"
                                        style={{ width: "60px", backgroundColor: "#89c764", height: "2px" }}
                                    />
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Mutual fund</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Demat account</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Investment in real estate</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Fixed Deposits</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">Bonds</a>
                                    </p>
                                    <p>
                                        <a href="#" className="text-white text-decoration-none">life Insurance</a>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </section>
                    <div
                        className="text-center p-3"
                        style={{ backgroundColor: "#446399", fontWeight: "600" }}
                    >
                        © 2023 Copyright:
                        <a className="text-white ms-1 text-decoration-none" href="https://compliancekare.com/"
                        >Compliancekare.com</a
                        > Design & Development by <a href="https://ndtechland.com/" target='_blank' rel="noreferrer" className="text-white text-decoration-none ms-1" style={{ fontWeight: "700" }}>ND Techland Pvt. Ltd</a>
                    </div>
                </footer>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                footer a {
                    transition: all 0.3s ease !important;
                    display: inline-block;
                }
                footer a:hover {
                    color: #89c764 !important;
                    transform: translateX(4px);
                }
                footer p {
                    margin-bottom: 10px;
                }
                footer hr {
                    transition: width 0.3s ease;
                }
                footer .row > div:hover hr {
                    width: 100px !important;
                }
            `}} />
        </>
    )
}

export default Footer